import lrCreateuser from './_src/lrCreateuser.vue'

lrCreateuser.install = function(Vue) {
  Vue.component(lrCreateuser.name, lrCreateuser)
}

export default lrCreateuser